import { render, staticRenderFns } from "./BannerEdit.vue?vue&type=template&id=54bf83de&scoped=true&"
import script from "./BannerEdit.vue?vue&type=script&lang=js&"
export * from "./BannerEdit.vue?vue&type=script&lang=js&"
import style0 from "./BannerEdit.vue?vue&type=style&index=0&id=54bf83de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bf83de",
  null
  
)

export default component.exports